import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const ReadOnlyTutorialsViewPage = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const tutorial = location.state?.viewData;
    const descriptionHTML = tutorial?.description || "<p>No description available</p>";

    return (
        <div
            style={{
                minHeight: "100vh",
                background: "none",
                fontFamily: "Plus Jakarta Sans, sans-serif",
                padding: "32px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
            }}
        >
            {/* Header */}
            <div style={{ width: "100%", maxWidth: "890px", marginBottom: "24px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                    <button
                        onClick={() => navigate('/contentMangement', {
                            state: {
                                activeTab: 'Tutorial'
                            }
                        })}
                        style={{
                            width: "42px",
                            height: "42px",
                            borderRadius: "50%",
                            background: "#FFFFFF",
                            border: "none",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            backdropFilter: "blur(10px)"
                        }}
                    >
                        <ArrowLeft size={20} color="#171717" />
                    </button>
                    <h1
                        className='font-clash-display'
                        style={{
                            fontWeight: "600",
                            fontSize: "24px",
                            lineHeight: "32px",
                            color: "#374151",
                            margin: 0
                        }}
                    >
                        {tutorial?.title}
                    </h1>
                </div>
            </div>

            {/* Content Box */}
            <div
                style={{
                    width: "100%",
                    maxWidth: "890px",
                    backgroundColor: "#FFFFFF",
                    borderRadius: "16px",
                    border: "1px solid #E5E7EB",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                    padding: "32px"
                }}
            >
                {/* Render the HTML safely */}
                <div
                    dangerouslySetInnerHTML={{ __html: descriptionHTML }}
                    style={{ fontSize: "14px", lineHeight: "22px", color: "#374151" }}
                />
            </div>
        </div>
    );
};

export default ReadOnlyTutorialsViewPage;
